/* JOM Wishlist v1.0 — localStorage toggle, visual validation */
(function () {
  'use strict';

  var STORAGE_KEY = 'jom_wishlist';
  var HEART_SVG = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isSaved(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }

  function toggle(id) {
    var list = getWishlist();
    var idx = list.indexOf(String(id));
    if (idx === -1) { list.push(String(id)); }
    else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1;
  }

  function makeButton(productId, productTitle) {
    var btn = document.createElement('button');
    btn.className = 'jom-wishlist-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Guardar ' + (productTitle || ''));
    btn.innerHTML = HEART_SVG;
    if (isSaved(productId)) btn.classList.add('is-saved');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var saved = toggle(productId);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-label', (saved ? 'Remover ' : 'Guardar ') + (productTitle || ''));
    });
    return btn;
  }

  function injectButtons() {
    var cards = document.querySelectorAll('[data-product-id]:not([data-jom-wl])');
    cards.forEach(function (card) {
      var id = card.dataset.productId;
      var title = card.dataset.productTitle || '';
      var media = card.querySelector('.media, .card__media');
      if (!media || !id) return;
      if (media.style.position !== 'relative') media.style.position = 'relative';
      media.appendChild(makeButton(id, title));
      card.setAttribute('data-jom-wl', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectButtons);
  } else {
    injectButtons();
  }

  /* Re-inject after Shopify section re-renders (theme editor) */
  document.addEventListener('shopify:section:load', injectButtons);
})();
